import { Field as ChakraField } from '@chakra-ui/react';
import * as React from 'react';

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
  fontSize?: 'xs' | 'sm';
}

const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  (
    {
      label,
      fontSize = 'sm',
      children,
      helperText,
      errorText,
      optionalText,
      ...rest
    },
    ref
  ) => (
    <ChakraField.Root ref={ref} gap={fontSize === 'sm' ? 1 : 0.5} {...rest}>
      {label && (
        <ChakraField.Label
          color="gray.700"
          fontSize={fontSize}
          fontWeight="medium"
          _disabled={{ color: 'gray.400', opacity: 1 }}
        >
          {label}
          <ChakraField.RequiredIndicator fallback={optionalText} />
        </ChakraField.Label>
      )}
      {children}
      {helperText && (
        <ChakraField.HelperText>{helperText}</ChakraField.HelperText>
      )}
      {errorText && (
        <ChakraField.ErrorText fontSize={fontSize} fontWeight="normal">
          {errorText}
        </ChakraField.ErrorText>
      )}
    </ChakraField.Root>
  )
);

export default Field;
